import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomMessages } from '@shared';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { EasyDialog } from '../easy-dialog/easy-dialog';

@Component({
  selector: 'app-mail-download',
  templateUrl: './mail-download.component.html',
  styleUrls: ['./mail-download.component.scss'],
  providers: [TranslatePipe]
})
export class MailDownloadComponent implements OnInit {
  userTeamType: string;

  constructor(private commonService: CommonService, public dialog: EasyDialog, private ts: TranslatePipe, private customMessage: CustomMessages, private router: Router) { }

  commonDTO: CommonDTO = new CommonDTO();
  ngOnInit() {
    this.userTeamType = localStorage.getItem('userTeamType');
    this.downloadTemplate();
  }

  downloadTemplate() {
    this.commonDTO.userType = this.userTeamType;
    this.commonService.exportPowerPoint(this.commonDTO).subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      if (this.userTeamType == "Auditee Area")
        link.download = "CAMS_User_Guide_For_Auditee" + ".ppsx";
      else
        link.download = "CAMS_User_Guide_For_Auditor" + ".ppsx";
      link.click();
      this.redirect();

    },
      (error) => {
        if (error.error.msgId == undefined || error.error.msgId == '') {
          error.error.msgId = 'cams.label.common.errorOccuredInOperation';
          this.customMessage.showErrorMessage(error.error.msgId, '');
        }
        else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
        this.redirect();
      }
    );
  }

  redirect() {
    if (this.userTeamType == 'Auditee Area')
      this.router.navigate(['/auditeehome/auditeehome']);
    else
      this.router.navigate(['/auditorhome/auditorhome']);
  }
}
